<template>
    <div id="loginPage">
        <div
            class="d-flex flex-column rounded align-items-center py-4 bg-white"
        >
            <lazada-banners />
            <div class="lazada-title">Top up with Home Credit now!</div>
            <div class="lazada-content">
                Experience fast & convenient payments when you <br />
                top up your Lazada Wallet with Home Credit!
            </div>
            <div class="col-sm-12 icon-padding">
                <div class="icon-body">
                    <div class="lazada-gift-card"></div>
                    <div class="lazada-icon-content font-weight-bold">
                        Get instant funds in your Lazada Wallet by paying with
                        Home Credit.
                    </div>
                </div>
                <div class="icon-body pt-4">
                    <div class="lazada-promo"></div>
                    <div class="lazada-icon-content pt-2 font-weight-bold">
                        Enjoy exclusive promos and discounts.
                    </div>
                </div>
                <div class="icon-body pt-4 pb-4">
                    <div class="lazada-app"></div>
                    <div class="lazada-icon-content font-weight-bold">
                        No need for physical card, just use the Home Credit app.
                    </div>
                </div>
            </div>
        </div>
        <div
            class="d-flex flex-column rounded align-items-center text-center py-4 px-3 bg-white my-2"
        >
            <span class="font-md font-weight-bold mb-2">{{
                EnumLabels.CONTINUE_TO_PAYMENT
            }}</span>
            <span class="font-sm text-secondary"
                >Login securely to your Home Credit app to pay.</span
            >
            <info-bar class="mt-4 mb-2"
                >For selected existing Home Credit customers only</info-bar
            >
            <div class="col-10 col-xl-10 col-lg-10 col-sm-12 mt-4 mb-4">
                <button
                    type="button"
                    id="loginMobileBtn"
                    class="btn btn-danger btn-block rounded-lg py-2 mb-4"
                    @click="gotoMobilePage"
                >
                    <div class="font-sm text-center">
                        <img
                            alt=""
                            src="/img/hcpay/Phone.svg"
                            class="img-responsive mr-2"
                            style="height: auto; width: 1.5rem"
                        />
                        {{ EnumLabels.CONTINUE_WITH_MOBILE_NO }}
                    </div>
                </button>
            </div>
            <div class="font-xs text-center lazada-footer">
                <span
                    >By proceeding, you have agreed to share your information
                    <br />
                    with Home Credit.</span
                >
            </div>
            <div class="font-xs text-center lazada-footer">
                <span
                    >For more information,
                    <a
                        @click="click_faq"
                        class="text-success cursor-pointer"
                        data-bs-toggle="modal"
                        data-bs-target="#myModal"
                        >visit our FAQs</a
                    >.</span
                >
            </div>
            <lazada-return
                :eventName="'landing_click_cancel_go_back'"
                id="loginBackToStore"
                >{{ EnumLabels.CANCEL_AND_GOBACK_MERCHANT }}</lazada-return
            >
        </div>
        <div
            class="d-flex flex-column rounded align-items-center text-center py-4 px-3 bg-white my-2"
        >
            <download-opg-v3
                class="px-4"
                google-play-id="loginGooglePlayBtn"
                qr-code-id="loginQRCode"
            />
        </div>
        <lazada-faqs />
    </div>
</template>
<script>
import { analyticsDirective } from "../../directives/analytics.js";
import { ERROR } from "../../mixins/error_codes.js";
import { EnumLabels } from "../../enums/CommonString.js";
export default {
    data() {
        return {
            EnumLabels,
            transaction: this.$root.$data.transaction,
        };
    },
    directives: {
        analytics: analyticsDirective,
    },
    methods: {
        click_faq() {
            let g4Params = {
                ip: this.$root.transaction.ipAddress,
                user_agent: this.$root.$data.analyticsData.userAgent,
                phone: this.$root.$data.analyticsData.phone,
                operating_system:
                    this.$root.$data.analyticsData.operatingSystem.name +
                    "V" +
                    this.$root.$data.analyticsData.operatingSystem.version,
                browser:
                    this.$root.$data.analyticsData.browser.name +
                    "V" +
                    this.$root.$data.analyticsData.browser.version,
                transaction_type: "WT",
            };
            this.$root.triggerG4Event("landing_click_visit_faq", g4Params);
        },
        gotoMobilePage() {
            let g4Params = {
                ip: this.$root.transaction.ipAddress,
                user_agent: this.$root.$data.analyticsData.userAgent,
                phone: this.$root.$data.analyticsData.phone,
                operating_system:
                    this.$root.$data.analyticsData.operatingSystem.name +
                    "V" +
                    this.$root.$data.analyticsData.operatingSystem.version,
                browser:
                    this.$root.$data.analyticsData.browser.name +
                    "V" +
                    this.$root.$data.analyticsData.browser.version,
                transaction_type: "WT",
            };
            this.$root.triggerG4Event(
                "landing_click_cont_mobile_num",
                g4Params
            );

            this.changeView("lazada-mobile");
        },
        changeView(view) {
            this.$root.$data.view = view;
        },
        changeView(view) {
            this.$root.$data.view = view;
        },
    },
    created() {
        this.$root.$data.previousView = "lazada-home";

        let g4Params = {
            ip: this.$root.transaction.ipAddress,
            user_agent: this.$root.$data.analyticsData.userAgent,
            phone: this.$root.$data.analyticsData.phone,
            operating_system:
                this.$root.$data.analyticsData.operatingSystem.name +
                "V" +
                this.$root.$data.analyticsData.operatingSystem.version,
            browser:
                this.$root.$data.analyticsData.browser.name +
                "V" +
                this.$root.$data.analyticsData.browser.version,
            transaction_type: "WT",
        };
        this.$root.triggerG4Event("landing_page", g4Params);

        sessionStorage.setItem("transaction_type", "WT");
        sessionStorage.setItem("ip", this.$root.transaction.ipAddress);
        sessionStorage.setItem(
            "user_agent",
            this.$root.$data.analyticsData.userAgent
        );
        sessionStorage.setItem("phone", this.$root.$data.analyticsData.phone);
        sessionStorage.setItem(
            "operating_system",
            this.$root.$data.analyticsData.operatingSystem.name +
                "V" +
                this.$root.$data.analyticsData.operatingSystem.version
        );
        sessionStorage.setItem(
            "browser",
            this.$root.$data.analyticsData.browser.name +
                "V" +
                this.$root.$data.analyticsData.browser.version
        );
    },
};
</script>
<style scoped>
.icon-padding {
    margin-top: 41px;
    padding: 0 32px 0 32px;
}
.lazada-title {
    width: 358px;
    height: 26px;
    text-align: left;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
        Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
    font-weight: bold;
    font-size: 20px;
    letter-spacing: 0px;
    color: #212121;
    opacity: 1;
    padding: 20px 0 0 0;
}
.icon-body {
    margin: auto;
    overflow: hidden;
    width: 87%;
}
.lazada-content {
    width: 358px;
    height: 38px;
    float: right;
    text-align: left;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
        Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
    font-size: 14px;
    letter-spacing: 0px;
    color: #000000de;
    padding: 30px 0 20px 0;
}
.lazada-gift-card {
    /* Layout Properties */
    float: left;
    left: 40px;
    width: 53px;
    height: 43px;
    /* UI Properties */
    background: transparent url("/img/lazada/gift-card-icon.png") 0% 0%
        no-repeat padding-box;
    background-size: contain;
    opacity: 1;
}
.lazada-promo {
    /* Layout Properties */
    float: left;
    left: 40px;
    width: 53px;
    height: 43px;
    /* UI Properties */
    background: transparent url("/img/lazada/promo-icon.png") 0% 0% no-repeat
        padding-box;
    background-size: contain;
    opacity: 1;
}
.lazada-app {
    /* Layout Properties */
    float: left;
    left: 40px;
    width: 53px;
    height: 43px;
    /* UI Properties */
    background: transparent url("/img/lazada/app-icon.png") 0% 0% no-repeat
        padding-box;
    background-size: contain;
    opacity: 1;
}
.lazada-icon-content {
    text-align: left;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
        Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
    font-size: 14px;
    color: #000000de;
    right: 20px;
    opacity: 1;
}
.border-lines {
    overflow: hidden;
    text-align: center;
    color: #a6a6a6;
    font-size: 12px;
}
.border-lines:before,
.border-lines:after {
    background-color: #a6a6a6;
    color: #a6a6a6;
    content: "";
    display: inline-block;
    height: 1px;
    position: relative;
    vertical-align: middle;
    width: 50%;
}
.border-lines:before {
    right: 0.5em;
    margin-left: -50%;
}
.border-lines:after {
    left: 0.5em;
    margin-right: -50%;
}
.lazada-footer {
    padding-bottom: 24px;
}
.cursor-pointer {
    cursor: pointer;
}

@media (min-width: 372px) and (max-width: 1024px) {
    .icon-body {
        width: 100%;
    }
    .lazada-icon-content {
        right: 2px;
    }
    .lazada-gift-card {
        /* Layout Properties */
        left: 20px;
    }
    .lazada-promo {
        /* Layout Properties */
        left: 20px;
    }
    .lazada-app {
        /* Layout Properties */
        left: 20px;
    }
    .lazada-title {
        width: 100%;
        font-size: 16px;
        padding: 20px 25px 0 25px;
    }
    .lazada-content {
        width: 100%;
        padding: 30px 25px 20px 25px;
    }
}

@media (min-width: 120px) and (max-width: 370px) {
    .icon-body {
        width: 100%;
    }
    .lazada-icon-content {
        right: 2px;
    }
    .lazada-gift-card {
        /* Layout Properties */
        left: 20px;
    }
    .lazada-promo {
        /* Layout Properties */
        left: 20px;
    }
    .lazada-app {
        /* Layout Properties */
        left: 20px;
    }
    .lazada-title {
        width: 100%;
        font-size: 14px;
        padding: 20px 25px 0 25px;
    }
    .lazada-content {
        width: 100%;
        padding: 30px 25px 20px 25px;
    }
}
</style>
